import { useEffect } from 'react'
import T from 'prop-types'
import Container from 'components/Container'
import Editorial from 'components/Editorial'
import Button from 'components/Button'
import useSession from 'hooks/useSession'
import { removeItem } from 'lib/storage'
import Header from 'apps/booking/components/Header'

export default function FluRejection({
  match: {
    params: { orgUnit },
  },
}) {
  // Flush the session storage to prevent user from going back and getting confused
  useEffect(() => {
    removeItem('bookingState')
  }, [])

  // Get name
  const { clearSession } = useSession()

  return (
    <>
      <Header seoTitle="Beklager, du kan ikke bestille time" />

      <Container size="wizard" style={{ paddingBottom: '3rem' }}>
        <h1>Beklager, du kan ikke bestille time</h1>

        <Editorial>
          <p>
            Din kommune har ikke tilgjengeliggjort influensavaksinen for deg eller din aldersgruppe
            enda.
          </p>
          <p>Ta kontakt med din kommune om du mener dette er feil.</p>
        </Editorial>

        <Button onClick={() => clearSession(`/${orgUnit}`)} primary>
          Avslutt og logg ut
        </Button>
      </Container>
    </>
  )
}

FluRejection.propTypes = {
  match: T.shape({
    params: T.shape({
      orgUnit: T.string.isRequired,
    }).isRequired,
  }).isRequired,
}
